export const SESSION_STORAGE_KEYS = {
  USER_ID: "userId",
  MESSAGES: "messages",
};
